import { useEffect, useRef } from 'react'
import { useState } from 'react'
import Select from 'react-select';
import { post, get } from '../../services/api'
import { TailSpin } from "react-loader-spinner";
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';
import { useNavigate } from "react-router-dom";
import { logout } from "../../auth";


function FiltrosPainelBordo({ onFiltrarClick, dadosCarregados }) {
    const navigate = useNavigate();

    const [regioes, setRegioes] = useState(null);
    const [filtroRegiao, setFiltroRegiao] = useState(null);
    const [filiais, setFiliais] = useState(null);
    const [filtroFilial, setFiltroFilial] = useState(null);
    const [mesSelecionado, setMesSelecionado] = useState(null);
    const [filtrarAutomatico, setFiltrarAutomatico] = useState(null);

    const UsuarioMaster = 1;
    const Gerente = 3;
    const GerenteRegional = 4;

    useEffect(() => {
        carregarMesAnoPadroes();
        carregarFiltrosPadroes();
    }, []);

    useEffect(() => {
        handleFiltrarButtonClick();
    }, [filtrarAutomatico]);


    function handleFiltrarButtonClick() {
        if (filtroFilial)
            onFiltrarClick(filtroFilial, mesSelecionado.value);
    }

    async function PermissaoUsuario() {
        const idDepartamentoUsuario = localStorage.getItem("iddepartamentousuario");
        const idUsuario = localStorage.getItem("idusuario");

        try {
            const permissoes = await get(`/permissoes?usuario=${idUsuario}&departamento=${idDepartamentoUsuario}`)

            for (const permissao of permissoes)
                switch (permissao.id_tipo) {
                    case 1: return UsuarioMaster
                    case 2: return Gerente
                    case 4: return GerenteRegional
                }
            
            //Usuario não tem permissão valida, logo deve voltar ao login
            logout();
            navigate("/login");
        } catch (error) {
            if (error.response) {
                console.error('Erro na resposta do servidor:', error.response.data);
            } else if (error.request) {
                console.error('Sem resposta do servidor:', error.request);
            } else {
                console.error('Erro durante a configuração da requisição:', error.message);
            }
        }
    }

    function carregarMesAnoPadroes() {
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();

        const mesAnoPadrao = {
            value: `${mesAtual}-${anoAtual}`,
            label: `${meses[mesAtual - 1]}/${anoAtual}`
        };

        setMesSelecionado(mesAnoPadrao);

    }

    async function carregarFiltrosPadroes() {
        const idFilialUsuario = localStorage.getItem("idfilialusuario");
        const nomeFilial = localStorage.getItem("nomefilialusuario");
        
        if (await PermissaoUsuario() == UsuarioMaster) {
            const regioes = await fetchRegioes(0);
            setRegioes(regioes);

            let todasRegioesSelecionadas = [];
            for (const r of regioes) {
                todasRegioesSelecionadas.push(r.id_regiao);
            }

            setFiltroRegiao(todasRegioesSelecionadas);
            fetchAllFiliais(todasRegioesSelecionadas);
        }

        if (await PermissaoUsuario() == Gerente) {
            const regioes = await fetchRegioes(idFilialUsuario);
            setRegioes(regioes);

            let regioesGerente = [];

            for (const r of regioes) {
                regioesGerente.push(r.id_regiao);
            }
            setFiltroRegiao(regioesGerente);

            const filiais = [{ cod_sabium: idFilialUsuario, nome: nomeFilial }];
            setFiliais(filiais);

            let filiaisGerente = [];
            filiaisGerente.push(idFilialUsuario);
            setFiltroFilial(filiaisGerente);
            
            setFiltrarAutomatico(idFilialUsuario);
        }

        if (await PermissaoUsuario() == GerenteRegional) {
            const idUsuario = localStorage.getItem('idusuario');
            
            const regioes = await fetchRegioesGerenteRegional(idUsuario);

            if (Array.isArray(regioes)) {

                setRegioes(regioes);

                let regioesGerenteRegional = [];

                for (const r of regioes) {
                    regioesGerenteRegional.push(r.id_regiao);
                }
                setFiltroRegiao(regioesGerenteRegional);
                fetchAllFiliais(regioesGerenteRegional);
            }
        }
    }

    async function fetchRegioes(idFilialUsuario) {
        const idFilial = idFilialUsuario;
        const requisicao = { idFilial: idFilial }
        const regioes = await post('/vendedores/regioes', requisicao);
        return regioes;
    }

    async function fetchAllFiliais(regiaoSelecionada) {
        const requisicao = { idRegiao: regiaoSelecionada }
        const filiais = await post('/vendedores/filiais', requisicao);
        setFiliais(filiais);

        let todasFiliaisSelecionadas = [];
        for (const f of filiais) {
            todasFiliaisSelecionadas.push(f.cod_sabium);
        }

        setFiltroFilial(todasFiliaisSelecionadas);
        setFiltrarAutomatico(todasFiliaisSelecionadas);
    }

    async function fetchFiliais(regiaoSelecionada) {
        const requisicao = { idRegiao: regiaoSelecionada }
        const filiais = await post('/vendedores/filiais', requisicao);
        setFiliais(filiais);
    }

    async function fetchRegioesGerenteRegional(idUsuario) {
        const requisicao = { idUsuario: idUsuario }
        const regioes = await post('/vendedores/regioesgerenteregional', requisicao);
        return regioes;
    }

    const handleChangeRegiao = async (selectedOption) => {
        setFiliais([]); // Se a opção de região for limpa, limpa também as opções de filiais
        setFiltroFilial(null);
        setFiltroRegiao(selectedOption);
        if (selectedOption) {
            fetchFiliais(selectedOption); // Atualiza as filiais com base na região selecionada
        }
    };

    const handleChangeMes = (selectedOption) => {
        setMesSelecionado(selectedOption);
    };

    const optionsMeses = () => {
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();

        const options = [];

        let maximoMesesFiltro;

        if (anoAtual > 2024) {
            maximoMesesFiltro = 12;
        }

        if (anoAtual == 2024) {
            maximoMesesFiltro = mesAtual;
        }

        for (let i = 0; i < maximoMesesFiltro; i++) {
            let mes = mesAtual - i;
            let ano = anoAtual;

            if (mes <= 0) {
                mes += 12;
                ano -= 1;
            }

            const mesLabel = meses[mes - 1]; // Subtrai 1 para compensar o índice baseado em zero
            const optionValue = `${mes}-${ano}`;
            const optionLabel = `${mesLabel}/${ano}`;
            options.unshift({ value: optionValue, label: optionLabel });
        }

        return options;
    }

    const optionsRegioes = Array.isArray(regioes) ? regioes.map((regiao) => ({
        value: regiao.id_regiao,
        label: regiao.nome_regiao,
    })) : [];



    const optionsFiliais = Array.isArray(filiais) ? filiais.map((filial) => ({
        value: filial.cod_sabium,
        label: filial.cod_sabium - 10000 + ' - ' + filial.nome,
    })) : [];

    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';

    return (
        <div className="flex md:items-center justify-between lg:justify-center gap-1 lg:gap-4 mx-4 font-mulish font-medium text-sm flex-wrap lg:flex-nowrap flex-col md:flex-row">
            <p className="font-poppins font-semibold text-base text-white pr-2">Filtrar: </p>
            <div className="custom-multiselect-item">
                <CustomMultiSelect
                    selectedOptions={filtroRegiao}
                    setSelectedOptions={setFiltroRegiao}
                    filteredOptions={optionsRegioes}
                    placeholder='Regiões'
                    disabled={false}
                    onChange={(regiao) => handleChangeRegiao(regiao)}
                    display="chip"
                    maxSelectedLabels={3}
                />
            </div>


            <div className="custom-multiselect-item">
                <CustomMultiSelect
                    selectedOptions={filtroFilial}
                    setSelectedOptions={setFiltroFilial}
                    filteredOptions={optionsFiliais}
                    placeholder='Filiais'
                    disabled={false}
                    onChange={() => (false)}
                    display="chip"
                    maxSelectedLabels={1}
                />
            </div>

            <div className="select-container">
                <Select
                    name="mes"
                    className="react-select"
                    classNamePrefix="react-select"
                    value={mesSelecionado}
                    options={optionsMeses()}
                    onChange={handleChangeMes}
                    isClearable={false}
                    isSearchable={false}
                    placeholder="Selecione o mês"
                    noOptionsMessage={mensagemNenhumaOpcaoAlternativa}
                />
            </div>
            <button onClick={handleFiltrarButtonClick} className="bg-gray-c2 rounded text-white h-10 px-6">
                {dadosCarregados ? (
                    "Atualizar"
                ) : (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <TailSpin color="#ffffff" height={24} width={59} />
                    </div>
                )}
            </button>
        </div>
    )
}

export default FiltrosPainelBordo